import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client/core'
import type {
  QueryOptions,
  MutationOptions,
  ApolloQueryResult,
  FetchResult,
  OperationVariables,
} from '@apollo/client/core'
import fetch from 'cross-fetch'
import { possibleTypes } from '@core/config/possible-types.generated.json'

export default defineNuxtPlugin({
  name: 'apollo',
  dependsOn: ['i18n'],
  setup() {
    try {
      const { dataGateway, name, version } = useRuntimeConfig().public
      const httpLink = createHttpLink({
        uri: dataGateway.apiEndpoint,
        headers: {
          'apollographql-client-name': `${name}/client`,
          'apollographql-client-version': version,
        },
        fetch,
      })

      const apolloClient = new ApolloClient({
        link: httpLink,
        cache: new InMemoryCache({ possibleTypes }),
      })

      const query = async <Response, Variables extends OperationVariables>(
        options: QueryOptions<Variables, Response>,
      ): Promise<ApolloQueryResult<Response>> => {
        return await apolloClient.query<Response, Variables>(options)
      }

      const mutate = async <Response, Variables extends OperationVariables>(
        options: MutationOptions<Response, Variables>,
      ): Promise<FetchResult<Response>> => {
        return await apolloClient.mutate<Response, Variables>(options)
      }

      return { provide: { apollo: { query, mutate } } }
    } catch (e) {
      useLogger('plugin:apollo').error(e)
      throw e
    }
  },
})
